function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 16 7 C 13.35207 7 11.051929 8.2374781 9.40625 10.0625 C 9.2703551 10.046301 9.1477293 10 9 10 C 6.8026661 10 5 11.802666 5 14 C 3.2703261 15.054754 2 16.834851 2 19 C 2 22.301625 4.6983746 25 8 25 L 24 25 C 27.301625 25 30 22.301625 30 19 C 30 15.842292 27.509852 13.314931 24.40625 13.09375 C 23.183479 9.5733113 19.926695 7 16 7 z M 16 9 C 19.27847 9 22.011594 11.253351 22.78125 14.28125 L 22.96875 15.0625 L 23.8125 15.03125 C 24.02413 15.019087 24.071091 15 24 15 C 26.220375 15 28 16.779625 28 19 C 28 21.220375 26.220375 23 24 23 L 8 23 C 5.7796254 23 4 21.220375 4 19 C 4 17.338324 5.0091817 15.922353 6.4375 15.3125 L 7.125 15.03125 L 7.03125 14.28125 C 7.0103607 14.119051 7 14.025078 7 14 C 7 12.883334 7.8833339 12 9 12 C 9.14 12 9.2952692 12.02145 9.46875 12.0625 L 10.09375 12.21875 L 10.46875 11.71875 C 11.751887 10.073635 13.75001 9 16 9 z M 13 15 L 10 18 L 13 21 L 13 19 L 19 19 L 19 21 L 22 18 L 19 15 L 19 17 L 13 17 L 13 15 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/remote-working.de0d13c1.svg";
export { SvgComponent as ReactComponent };